import { render, staticRenderFns } from "./JoinRoundCornerIcon.vue?vue&type=template&id=39137a15&"
import script from "./JoinRoundCornerIcon.vue?vue&type=script&lang=js&"
export * from "./JoinRoundCornerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports